import React, { useState, useEffect, Fragment, useRef } from 'react'
import LandingLayout from '../../_layouts/Landing'
import RenderProfilePicture from '../../_helpers/profile-picture'

import { faUserMd } from '@fortawesome/free-solid-svg-icons'
import { getCookie, setCookie } from '../../_helpers/cookieJar'
import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import { doctorService } from '../../_services/doctor.service'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Row, Col, Button, Spinner, Dropdown } from 'react-bootstrap'

function MessageLink({ action, code, locations }) {
  return (
    <Row className='my-4 text-center'>
      <Col xs={{ span: 12, offset: 0 }} sm={{ span: 10, offset: 1 }}>
        {locations.length > 1 && (
          <Dropdown>
            <Dropdown.Toggle
              style={{
                width: '100%',
                color: '#ffffff',
                borderRadius: '1.5em',
                backgroundColor: '#008CFF'
              }}
              variant='primary'
              id='dropdown-basic'
            >
              {getCookie('hasAccount') ? 'Send a Message' : action.data.title}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {locations.map((location, index) => {
                return (
                  <Dropdown.Item
                    href={`${process.env.REACT_APP_PATIENT_URL}/messages/stream/${code}?location=${location.id}`}
                    key={index}
                  >
                    {location.name}
                  </Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          </Dropdown>
        )}

        {locations.length === 1 && (
          <Button
            className='w-100 call__to__action--btn'
            href={`${process.env.REACT_APP_PATIENT_URL}/messages/stream/${code}?location=${locations[0].id}`}
          >
            {getCookie('hasAccount') ? 'Send a Message' : action.data.title}
          </Button>
        )}

        {locations.length === 0 && (
          <Button
            className='w-100 call__to__action--btn'
            href={`${process.env.REACT_APP_PATIENT_URL}/messages/stream/${code}`}
          >
            {getCookie('hasAccount') ? 'Send a Message' : action.data.title}
          </Button>
        )}
      </Col>
    </Row>
  )
}

function FormLink({ action, code }) {
  return (
    <Row className='my-4 text-center'>
      <Col xs={{ span: 12, offset: 0 }} sm={{ span: 10, offset: 1 }}>
        <Button
          size='lg'
          onClick={() => {
            window.location = `${process.env.REACT_APP_PATIENT_URL}/forms/request/${action.data.formId}/${code}`
          }}
          className='w-100 call__to__action--btn'
        >
          {action.data.title}
        </Button>
      </Col>
    </Row>
  )
}

export default function Landing() {
  const [doctor, setDoctor] = useState({})
  const [loading, setLoading] = useState(true)
  const [doctorCode, setDoctorCode] = useState('')

  const contentDOM = useRef()

  useEffect(() => {
    const domain = window.location.hostname.split('.')[0]

    setDoctorCode(domain)

    doctorService
      .getByCode(domain)
      .then((response) => {
        setDoctor(response)
        setLoading(false)

        if (response.provider) {
          setCookie('client-logo', response.provider.logo, { maxAge: 600 })
          setCookie('client-name', response.provider.name, { maxAge: 600 })
        }

        contentDOM.current.innerHTML = response.bio
      })
      .catch(() => {
        setLoading(false)
        setDoctor(false)
      })
  }, [])

  return (
    <LandingLayout
      loading={loading}
      providerLogo={doctor && doctor.provider && doctor.provider.logo}
    >
      <Row>
        {loading && (
          <Col xs='12' className='m-auto text-center'>
            <Spinner animation='border' />
          </Col>
        )}

        {!loading && !doctor && <h3>Page not found</h3>}

        {!loading && doctor && (
          <Fragment>
            <Col lg='12' xl='4'>
              <Row className='text-center'>
                <Col lg='12'>
                  <h2 className='fw-bold'>
                    {doctor.firstName} {doctor.lastName}
                  </h2>
                </Col>
                <Col lg='12'>
                  <RenderProfilePicture
                    image={doctor.profileUrlSizes.lrg}
                    width={150}
                    height={150}
                    className='my-3 mx-auto shadow-sm'
                  />
                </Col>
                <Col lg='12' className='mb-1'>
                  <small>
                    <FontAwesomeIcon
                      icon={faUserMd}
                      className='fa-fw text-muted opacity-50'
                    />
                    &nbsp; {doctor.type}
                  </small>
                </Col>
                <Col lg='12' className='text-muted'>
                  <small>
                    <FontAwesomeIcon
                      icon={faBuilding}
                      className='fa-fw opacity-50'
                    />
                    &nbsp; {doctor.provider && doctor.provider.name}
                  </small>
                </Col>
              </Row>

              <br />

              {doctor.actions &&
                doctor.actions.data.map((action, index) => {
                  if (action.type === 'MESSAGE') {
                    return (
                      <MessageLink
                        key={index}
                        action={action}
                        code={doctorCode}
                        locations={
                          doctor.locations ? doctor.locations.data : []
                        }
                      />
                    )
                  } else if (action.type === 'FORM') {
                    return (
                      <FormLink key={index} action={action} code={doctorCode} />
                    )
                  }

                  return null
                })}
              <br />
            </Col>
            <Col>
              <Row>
                <Col>
                  <div id='bio' ref={contentDOM}></div>
                </Col>
              </Row>
            </Col>
          </Fragment>
        )}
      </Row>
    </LandingLayout>
  )
}
